<template>
	<resource-list-item-skeleton title subtitle divided>

		<template #right>
			<div class="flex items-center h-24">
				<chip-skeleton class="mr-4 md:mr-16" x-small :width="props.withRanks ? 60 : 70"/>
				<Icon :icon="icons.next" color="gray-400"/>
			</div>
		</template>

		<template #below>
			<div class="flex flex-column justify-between" :class="{'md:flex-row md:items-center': !props.forceMobileLayout}">
				<div v-if="props.withRanks" class="flex overflow-x-auto overflow-y-hidden border-box px-16 lg:px-24 mb--8 pb-16 pt-4" :class="{'md:pt-0': !props.forceMobileLayout}">
					<chip-skeleton class="mr-4" small width="60"/>
					<chip-skeleton class="mr-4" small width="60"/>
					<chip-skeleton class="mr-4" small width="60"/>
					<chip-skeleton class="mr-4" small width="60"/>
				</div>
				<span v-else></span>

				<btn-group class="justify-end" text>
					<btn large text disabled>
						<skeleton :height="24" rounded :width="36"/>
					</btn>
					<btn large text disabled>
						<skeleton :height="24" rounded :width="36"/>
					</btn>
				</btn-group>
			</div>
		</template>
	</resource-list-item-skeleton>
</template>

<script setup lang="ts">
import {nextIcon} from "../../../config";

const props = defineProps<{
	withRanks?: boolean,

	// Whether the bottom content row shall be wrapped even when on desktop devices
	forceMobileLayout?: boolean,
}>();

const icons = {
	next: nextIcon,
};
</script>